import { useEffect, useState } from 'react';

/**
 * Stan połączenia z siecią.
 *
 * Przy włączonej trwałej pamięci podręcznej Firestore aplikacja działa dalej
 * po zerwaniu łącza — i właśnie dlatego trzeba to pokazać. Bez wskaźnika
 * operator nie odróżni pracy na danych z dysku od pracy na danych bieżących
 * i mógłby uznać, że jego zapis dotarł do serwera, choć czeka w kolejce.
 *
 * Opiera się na navigator.onLine, który wykrywa brak interfejsu sieciowego,
 * ale nie rozpozna sytuacji „jest wifi, nie ma internetu". To wystarczające
 * przybliżenie dla ostrzeżenia — Firestore i tak sam dosyła zaległe zapisy.
 */
export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine
  );

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return isOnline;
}

export default useOnlineStatus;
